export function createVideoBackgroundListener (elements: NodeListOf<HTMLVideoElement>): void {
    window.addEventListener('resize', () => startPlayAllVideos(elements), { passive: true });

    startPlayAllVideos(elements);
}

function startPlayAllVideos (elements: NodeListOf<HTMLVideoElement>): void {
    elements.forEach((element: HTMLVideoElement) => element.play());
}
